import React from 'react';
import MainMenu from '../components/MainMenu';
import '../styles/Contact.css';
import DotGrid from '../components/DotGrid';

const ContactPage = () => {
  return (
    <div className="projects-page">
      <MainMenu />

      {/* <div>
        <DotGrid
          dotSize={2}
          dotSpacing={50}
          lineThickness={1}
          showLines={false}
          lineColor="rgba(255, 255, 255, 0.5)"
          dotColor="white"
          edgePadding={40}
          zoneSpacing={2}
          labelSize="18px"
          zoneHoverColor="rgba(0, 0, 0, 0.6)"
          zoneColor="rgba(100, 100, 100, 0.5)"
          mainMenuHeight={50}
          dividerColor="rgba(219, 219, 219, 0.46)"
        />
      </div> */}
      <div className="centered-image-wrapper">
        <img
          src="/images/email.webp"          
          alt="Contact Email"
          className="email-image"
        />
      </div>
    </div>
  );
}

export default ContactPage;
